import { eventEmitter } from "../eventEmitters/EventEmitters";
import { groupsList } from "./pageGroupsModel";

/*
 * A GROUP'S SLOT BOX IS DRAWN AS A STACK (2026-10-21, Chris: "instead of a single page slot box white rectangle, let's add a couple behind it so it looks like a 'stack' of 3 pages to indicate a group").
 * Two more white sheets sit behind the box, each shifted up and to the right, so a slot holding a group reads as several pages at a glance. Drawn from the box's own rectangle (its x, y, size) and
 * inserted BEFORE it, so it is behind; they carry no rectIndex (other code finds a box's rectangle by that) and take no pointer events (the box itself stays the only thing to hover or click).
 */
const SVG_NS = "http://www.w3.org/2000/svg";
const SHEETS = [{ dx: 5, dy: -5, shade: "#eef0f2" }, { dx: 10, dy: -10, shade: "#e1e5e8" }];     // nearest sheet first, so the farther one is inserted first and sits lowest

/** (re)draws the stack behind every box whose page is one of the owner's groups, and removes it from every other */
export const syncGroupStacks = (): void => {
  if (typeof document === "undefined") return;
  const keys = new Set(groupsList().map((g) => g.key));
  document.querySelectorAll("g[rectIndex]").forEach((box) => {
    box.querySelectorAll("rect[data-group-stack]").forEach((r) => r.remove());
    const main = box.querySelector("rect[id^=\"rect_\"]");
    const label = box.querySelector("text.slot-label-link, text[real-text]")?.getAttribute("real-text") || "";
    if (!main || !label || !keys.has(label)) return;
    const geometry = ["x", "y", "width", "height"].map((a) => parseFloat(main.getAttribute(a) || "0"));
    if (!(geometry[2] > 0 && geometry[3] > 0)) return;
    [...SHEETS].reverse().forEach((sheet) => {
      const r = document.createElementNS(SVG_NS, "rect");
      r.setAttribute("data-group-stack", "true");
      r.setAttribute("x", String(geometry[0] + sheet.dx));
      r.setAttribute("y", String(geometry[1] + sheet.dy));
      r.setAttribute("width", String(geometry[2]));
      r.setAttribute("height", String(geometry[3]));
      r.setAttribute("rx", main.getAttribute("rx") || "0");
      r.style.fill = sheet.shade;
      r.style.stroke = "#cfd5da";
      r.style.pointerEvents = "none";
      box.insertBefore(r, main);
    });
  });
};

// the groups arrive (or change) after the grid is drawn, so the stacks follow them
eventEmitter.addListener("pageGroupsUpdated", () => syncGroupStacks());
